import React, { useCallback, useMemo } from "react";
import "./styles.less";
import { AuthingButton } from "../../../../components/AuthingButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DownRcode } from "../../../../components/DownRcode";

export const ManufacturingOther = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const text = useMemo(() => {
    return {
      title: t("manufacturing.other.title"),
      item: [
        {
          title: t("manufacturing.other.item1.title"),
          desc: t("manufacturing.other.item1.desc"),
          icon: "https://files.authing.co/authing-website/manu-8-icon1.png",
          downUrl: "solution-chip-1.png",
          fromTag: "芯片解决方案",
        },
        {
          title: t("manufacturing.other.item2.title"),
          desc: t("manufacturing.other.item2.desc"),
          icon: "https://files.authing.co/authing-website/manu-8-icon2.png",
          downUrl: "solution-ai-1.png",
          fromTag: "机器人解决方案",
        },
        {
          title: t("manufacturing.other.item3.title"),
          desc: t("manufacturing.other.item3.desc"),
          icon: "https://files.authing.co/authing-website/manu-8-icon3.png",
          downUrl: "solution-airline-1.png",
          fromTag: "航空航天解决方案",
        },
        {
          title: t("manufacturing.other.item4.title"),
          desc: t("manufacturing.other.item4.desc"),
          icon: "https://files.authing.co/authing-website/manu-8-icon4.png",
          downUrl: "solution-medical-1.png",
          fromTag: "医药解决方案",
        },
      ],
    };
  }, [t]);

  const renderLi = useCallback((item, itemIndex) => {
    return (
      <div key={itemIndex} className="item">
        <div
          // style={{
          //   height: "100%",
          //   overflow: "hidden",
          // }}
          className="item-content"
        >
          <div className="icona">
            <img src={item.icon} alt={item.alt} width="100%" />
          </div>
          <div className="title line1">{item.title}</div>
          <div className="desc">{item.desc}</div>

          {/* <AuthingButton
              mode="small"
              onClick={() => {
                window.open(
                  `/authingform?from=manufacturing&fromTag=${
                    item.fromTag
                  }&download=${encodeURI(item.downUrl)}`
                );
              }}
            >
              {t("manufacturing.other.downText")}
            </AuthingButton> */}
        </div>
        <div className="down-rcode-img">
          <img
            src={`http://files.authing.co/authing-website/${item.downUrl}`}
            alt="authing"
          />
        </div>
      </div>
    );
  }, []);
  return (
    <div style={{ background: "#f7f8fa" }}>
      <div className="manufacturing-other basic-column">
        <h1 className="manufacturing-title basic-title">{text.title}</h1>
        <div className="pc-show">
          <div className="manufacturing-other-content basic-column">
            {text.item.map((item, itemIndex) => renderLi(item, itemIndex))}
          </div>
        </div>
        <div className="pad-show mobile-show">
          <div className="manufacturing-other-content basic-column">
            <div className="flex">
              {text.item
                .slice(0, 2)
                .map((item, itemIndex) => renderLi(item, itemIndex))}
            </div>
            <div className="flex">
              {text.item
                .slice(2, 4)
                .map((item, itemIndex) => renderLi(item, itemIndex))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
